import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=6e090db6&scoped=true"
import script from "./slider.vue?vue&type=script&lang=js"
export * from "./slider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e090db6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e090db6')) {
      api.createRecord('6e090db6', component.options)
    } else {
      api.reload('6e090db6', component.options)
    }
    module.hot.accept("./slider.vue?vue&type=template&id=6e090db6&scoped=true", function () {
      api.rerender('6e090db6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/stiker/slider.vue"
export default component.exports